// extracted by mini-css-extract-plugin
export var active = "_1u-d";
export var blink = "_1u-e";
export var container = "_1u-5";
export var controls = "_1u-0";
export var controlsRight = "_1u-1";
export var fakeCursor = "_1u-c";
export var hidden = "_1u-b";
export var quillContainerSmall = "_1u-7";
export var quillEditor = "_1u-6";
export var quillEditorSmall = "_1u-8";
export var quillFormatButtons = "_1u-a";
export var quillToolbar = "_1u-9";
export var removePadding = "_1u-2";
export var state = "_1u-3";
export var stateTitle = "_1u-4";